export default "__VITE_ASSET__C42dd7dc__"